import styles from "./trial-error-modal.module.scss";
import React from "react";
import Image from "next/image";
import errorIcon from "@/assets/icons/error-icon.svg";
import UpgradeButton from "@/components/common/upgrade-button";
import { useGlobalModalContext } from "@/providers/modal-provider/modal-provider";

const TrialErrorModal = () => {
  const { hideModal } = useGlobalModalContext();
  return (
    <div className={styles.wrapper}>
      <div className={styles.header_wrapper}>
        <Image src={errorIcon} alt="error" />
        <div className={styles.title}>
          Our AI Cover generation server is processing other song right now.
        </div>
        Please click &quot;Generate&quot; in 5 minutes again.
      </div>
      <div className={styles.footer_wrapper}>
        <div>
          To bypass these waiting limitations, please upgrade to premium plan.
        </div>
        <UpgradeButton onClick={hideModal} />
      </div>
    </div>
  );
};

export default TrialErrorModal;
